import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../provider/CommonContext";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import { Vortex } from 'react-loader-spinner'
function HighLowOpenIntrest() {
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([])
    const [type, settype] = useState('hoi');
    const [Symbol, setSymbol] = useState('Nifty');
    const [OptionSymbol, setOptionSymbol] = useState([]);
    let navigate = useNavigate();
    const [loadingshow, setloadingshow] = useState(false);
    let getOptionSymbol;
    useEffect(() => {
        setloadingshow(true)
        const getUrldate = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrldate}/sym/-`)
            .then((response) => response.json())
            .then((dataOptionSymbol) => {
                getOptionSymbol = dataOptionSymbol.data;
                setOptionSymbol(getOptionSymbol);
                setloadingshow(false)
                // console.log(abc,"abc")
                // console.log(getOptionSymbol, "getOptionSymbol")
            })
            .catch((error) => {
            });

        const getUrl = BaseURL + "HighLowOpenIntrest";
        fetch(`${getUrl}/MR/-/opt/${Symbol}/-/-/${type}/-/8`)
            .then((response) => response.json())
            .then((data) => {
                setData(data.data);
                // console.log(data.data, "highlow")
                setloadingshow(false)
            })
            .catch((error) => {
                //console.log("not found the api");
            });

    }, [type, Symbol])

    const moreContent = () => {
        navigate("/Futures-And-Options/Highest-in-OI-Options")
    }

    const handleSelect = (key) => {
        if (key === "highest")
            settype('hoi');
        else
            settype('loi');
    }
    return (
        <>
            <div className='market-inner-common market-mf-main'>
                <div className='ttmarket-header'>
                    <h4>Highest / Lowest in Open Interest</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>
                <Container className="add-border table-box">
                <div className='ipo-common mf-common  fo-common'>
                    <div className='holdings-selectopen'>

                    {/* aria-label="Select Symbol" */}
                        <select aria-label="Select Symbol" onChange={(event) => setSymbol(event.target.value)}>
                            <option value="-">Select Symbol</option>
                            {OptionSymbol && OptionSymbol.map(
                                ({ symbol }) => (
                                    <option value={symbol.trim()}>{symbol.trim()}</option>
                                )
                            )}
                        </select>
                    </div>
                    <Tabs defaultActiveKey="highest" transition={true} onSelect={(e) => handleSelect(e)}>
                        <Tab eventKey="highest" title="Highest">
                            <div className='mf-table table-responsive gainer-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Contract</th>
                                            <th className='text-right'>Expiry Date</th>
                                            <th className='text-right'>LTP(&#8377;)</th>
                                            <th className='text-right'>Strike Price</th>
                                            <th className='text-right'>Change(%)</th>
                                            <th className='text-right'>OI Change(%)</th>
                                        </tr>
                                    </thead>
                                    {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                    <tbody>
                                        {(data != null) && data.map(({ Symbol, ExpDate, LTP, FaOchange, chgOpenInt, StrikePrice }) => (
                                            <tr>
                                                <td className='text-left'>{Symbol}</td>
                                                <td className='text-right'>{format(parseISO(ExpDate.split('T')[0]), 'dd-MMM-yyyy')}</td>
                                                <td className='text-right'>{LTP != null ? LTP : 0}</td>
                                                <td className='text-right'>{StrikePrice != null ? StrikePrice : 0}</td>
                                                <td><p className={FaOchange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {FaOchange != null ? FaOchange.toFixed(2) : 0} </p></td>
                                                <td><p className={chgOpenInt.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {chgOpenInt != null ? chgOpenInt.toFixed(2) : 0} </p></td>
                                                {/* <td className='text-right'>{FaOchange.toFixed(2)}</td>
                                                <td className='text-right'>{chgOpenInt.toFixed(2)}</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Tab>
                        <Tab eventKey="lowest" title="Lowest">
                            <div className='mf-table table-responsive gainer-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Contract</th>
                                            <th className='text-right'>Expiry Date</th>
                                            <th className='text-right'>LTP(&#8377;)</th>
                                            <th className='text-right'>Strike Price</th>
                                            <th className='text-right'>Change(%)</th>
                                            <th className='text-right'>OI Change(%)</th>
                                        </tr>
                                    </thead>
                                    {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                    <tbody>
                                        {(data != null) && data.map(({ Symbol, ExpDate, LTP, FaOchange, chgOpenInt, StrikePrice }) => (
                                            <tr>
                                                <td className='text-left'>{Symbol}</td>
                                                <td className='text-right'>{format(parseISO(ExpDate.split('T')[0]), 'dd-MMM-yyyy')}</td>
                                                <td className='text-right'>{LTP}</td>
                                                <td className='text-right'>{StrikePrice != null ? StrikePrice : 0}</td>
                                                <td><p className={FaOchange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {FaOchange != null ? FaOchange.toFixed(2) : 0} </p></td>
                                                <td><p className={chgOpenInt.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {chgOpenInt != null ? chgOpenInt.toFixed(2) : 0} </p></td>
                                                {/* <td className='text-right'>{FaOchange.toFixed(2)}</td>
                                                <td className='text-right'>{chgOpenInt.toFixed(2)}</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        </Tab>
                    </Tabs>
                </div>
                {loadingshow ? <div className="textcentervertex">
                    <Vortex
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="vortex-loading"
                        wrapperStyle={{}}
                        wrapperClass="vortex-wrapper"
                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                    />
                    <div className="model_popup">Please Wait...</div>
                </div> : ""
                }
                </Container>
            </div>
        </>
    )
}

export default HighLowOpenIntrest